import { giphyBlue, giphyLightGrey } from '@giphy/colors'
import styled, { css } from 'styled-components'

export const Canvas = styled.canvas`
    border-radius: 8px;
    cursor: pointer;
    margin: 0 auto 12px;
    user-select: none;
    width: 75px;

    &:active {
        opacity: 0.8;
    }
`

export const Label = styled.figcaption`
    color: ${giphyLightGrey};
`

export const Preview = styled.figure<{ active: boolean }>`
    grid-column: span 1;
    text-align: center;

    ${({ active }) =>
        active &&
        css`
            ${Canvas} {
                outline: 2px solid ${giphyBlue};
            }

            ${Label} {
                color: #fff;
                font-weight: bold;
            }
        `}
`
